<template>
  <div class="clinic-info">
    <Loading
      v-if="isLoading"
      class="crm-loading-wrapper"
    >
      Загрузка клиники
    </Loading>

    <template v-else>
      <div class="crm-title-row">
        <div class="clinic-title">
          {{ clinicInfo.appTitle || clinicInfo.title || '—' }}
        </div>
        <!-- v-if="!checkRoleAccess_(['ClinicAdministrator', 'MedicalCurator', 'Operator', 'Tech.operator'])" -->
      </div>

      <div class="line-title flex align-center justify-between">
        <div class="line-title-inner">
          Информация о юридическом лице
        </div>
        <template>
          <b-button
            v-if="!clinicInfo.legalPerson.name"
            class="ml-auto mr-2 z-10"
            variant="primary"
            @click="addClinicFace"
          >
            <b-icon icon="plus" />
          </b-button>
          <icon-edit
            v-if="isEditFace && clinicInfo.legalPerson.name"
            class="crm-icon edit-btn active z-10"
            @click="onClickCancelFace"
          />
          <icon-edit
            v-else-if="clinicInfo.legalPerson.name"
            class="crm-icon edit-btn z-10 bg-white"
            @click="editClinicFace"
          />
        </template>
      </div>
      <ClinicLegalPersonEdit
        v-if="isEditFace || isAddClinicFace"
        :id="clinicInfo.id"
        :is-edit-face="isEditFace"
        :is-add-clinic-face="isAddClinicFace"
        @legal-person-updated="handleLegalPersonUpdated"
        @onClickClose="handleCloseLegalPersonEdit"
      />
      <template v-else>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Сеть клиник
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.clinicNetwork ? clinicInfo.clinicNetwork.title : '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Юр. лицо
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.legalPerson.name || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title flex">
                ФИО руководителя
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.legalPerson.leaderFio || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title flex">
                Должность руководителя
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.legalPerson.leaderPosition || '—' }}
              </span>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Веб-сайт
              </p>
              <span class="crm-info-text">
                <a
                  v-if="clinicInfo.legalPerson.site"
                  :href="clinicInfo.legalPerson.site"
                  target="_blank"
                >
                  {{ clinicInfo.legalPerson.site }}
                </a>
                <template v-else>
                  —
                </template>
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                ОГРН
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.legalPerson.ogrn || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                ИНН
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.legalPerson.inn || '—' }}
              </span>
            </div>
          </div>
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                КПП
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.legalPerson.kpp || '—' }}
              </span>
            </div>
          </div>
        </div>

        <div
          v-for="(contact, i) in clinicInfo.legalPerson.contacts"
          :key="`${i} c`"
          class="clinics-form-fields"
        >
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Должность
              </p>
              <span class="crm-info-text">
                {{ contact.position|| '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                ФИО
              </p>
              <span class="crm-info-text">
                {{ contact.fio || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                E-mail
              </p>
              <span class="crm-info-text">
                {{ contact.email || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Телефон
              </p>
              <span class="crm-info-text">
                {{ contact.phoneNumber || '—' }}
              </span>
            </div>
          </div>
        </div>
      </template>

      <div class="line-title flex items-center justify-between">
        <div class="line-title-inner">
          Информация о клинике
        </div>
        <template v-if="checkFeatureAccess({ name: 'Редактирование информации клиники', url: '/clinics/:clinicId' })">
          <icon-edit
            v-if="isEdit"
            class="crm-icon edit-btn active z-10"
            @click="onClickCancel"
          />
          <icon-edit
            v-else
            class="crm-icon edit-btn z-10 bg-white"
            @click="editClinic"
          />
        </template>
      </div>

      <template v-if="isEdit">
        <div class="clinics-form-fields">
          <base-input
            v-model="$v.clinicInfoEditData.title.$model"
            :error="$v.clinicInfoEditData.title.$error"
            :errors="errorsValidation.title"
            :input-style="inputStyleProps"
            class="crm-form-field"
            label="Название клиники для приложения"
            placeholder="Введите название"
            required
          />
          <base-input
            v-model="clinicInfoEditData.medicalOrganizationOID"
            :input-style="inputStyleProps"
            class="crm-form-field"
            label="OID"
            placeholder="Введите номер"
          />
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label required">
                Город
              </div>
              <v-select
                v-model="$v.clinicInfoEditData.city.$model"
                :options="cities"
                placeholder="Выберите город"
                label="name"
                :clearable="true"
                class="crm-select"
              />
              <div
                v-if="$v.clinicInfoEditData.city.$error"
                class="validation-errors"
              >
                <span
                  class="validation-error-text"
                >
                  {{ errorsValidation.city[0] }}
                </span>
              </div>
            </div>
          </div>

          <div
            style="width: 500px"
            class="mr-2"
          >
            <label for="city">
              Адрес <span style="color: red">*</span>
            </label>
            <b-form-group>
              <b-form-input
                id="city"
                v-model="$v.clinicInfoEditData.address.$model"
                :state="!$v.clinicInfoEditData.address.$error"
                :errors="errorsValidation.address"
                :input-style="inputStyleProps"
                required
              />
              <b-form-invalid-feedback
                id="input-1-live-feedback"
              >
                Данное поле обязательно*
              </b-form-invalid-feedback>
            </b-form-group>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-label">
                Режим работы
              </p>
              <div class="crm-form-field">
                <div class="crm-form-input-prefix crm-bold">
                  с
                </div>
                <base-input
                  v-model="clinicInfoEditData.operatingHoursFrom"
                  class="crm-form-input"
                  type="text"
                  placeholder="8:00"
                  :input-style="{ ...inputStyleProps, width: '70px'}"
                  :disable-arrows="true"
                />

                <div class="divide-line" />

                <div class="crm-form-input-prefix crm-bold">
                  до
                </div>
                <base-input
                  v-model="clinicInfoEditData.operatingHoursTo"
                  class="crm-form-input"
                  type="text"
                  placeholder="20:00"
                  :input-style="{ ...inputStyleProps, width: '70px'}"
                  :disable-arrows="true"
                />
              </div>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Географические координаты
              </p>

              <div class="crm-form-fields">
                <base-input
                  v-model="$v.clinicInfoEditData.latitude.$model"
                  :error="$v.clinicInfoEditData.latitude.$error"
                  :errors="errorsValidation.latitude"
                  :input-style="inputStyleProps"
                  :mask="maskLatitude"
                  class="crm-form-field coord-input"
                >
                  <template v-slot:prefix>
                    <span class="coord-prefix">Ш.</span>
                  </template>
                </base-input>

                <base-input
                  v-model="$v.clinicInfoEditData.longitude.$model"
                  :error="$v.clinicInfoEditData.longitude.$error"
                  :errors="errorsValidation.longitude"
                  :input-style="inputStyleProps"
                  :mask="maskLongitude"
                  class="crm-form-field coord-input"
                >
                  <template v-slot:prefix>
                    <span class="coord-prefix">Д.</span>
                  </template>
                </base-input>
              </div>
            </div>
          </div>
        </div>

        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-field">
              <div class="crm-form-block">
                <p class="crm-label">
                  E-mail для гарантийных писем
                </p>

                <div
                  v-for="(contact, index) in $v.clinicInfoEditData.contactsForIL.$each.$iter"
                  :key="index + 's'"
                  class="crm-form-field-email"
                >
                  <base-input
                    v-model="contact.email.$model"
                    :input-style="inputStyleProps"
                    :style="{
                      flex: '1',
                      marginBottom: contact.email.$invalid ? '20px' : '0',
                    }"
                    placeholder="example@example.com"
                    :error="contact.email.$invalid"
                    :errors="['Некорректная почта']"
                  />

                  <icon-delete
                    class="crm-icon-delete crm-form-email-delete"
                    @click="deleteEmail(index)"
                  />
                </div>

                <base-button
                  :type="$const.SECONDARY_BUTTON"
                  class="width-unset without-border add-email"
                  @click="addEmail"
                >
                  <span>Добавить e-mail</span>
                </base-button>
              </div>
            </div>
            <div class="crm-form-field">
              <div class="crm-form-block">
                <p class="crm-label required">
                  Приоритет клиники
                </p>
                <v-select
                  v-model="$v.clinicInfoEditData.priority.$model"
                  :reduce="priority => priority.index"
                  :options="clinicPriorities"
                  :clearable="false"
                  class="crm-form-field person-select"
                  placeholder="Выберите приоритет"
                  label="title"
                />
                <div
                  v-if="$v.clinicInfoEditData.priority.$error"
                  class="validation-errors"
                >
                  <span
                    class="validation-error-text"
                  >
                    {{ errorsValidation.priority[0] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <base-input
            v-model="clinicInfoEditData.operatingHoursComment"
            :input-style="inputStyleProps"
            class="crm-form-field"
            label="Комментарий к режиму работы:"
            placeholder="Введите текст"
          />
        </div>

        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label">
                Услуги
              </div>
              <div class="crm-form-checkbox-list">
                <base-checkbox
                  v-for="(service, index) in clinicServices"
                  :key="service"
                  v-model="clinicInfoEditData.services"
                  :label="index"
                  class="crm-form-checkbox"
                >
                  <span class="crm-form-checkbox-text">
                    {{ service }}
                  </span>
                </base-checkbox>
              </div>
            </div>
          </div>
          <div class="crm-form-field">
            <div class="crm-form-block">
              <base-input
                v-model="clinicInfoEditData.specialComment"
                :input-style="{ ...inputStyleProps, height: '100px', marginBottom: '15px'}"
                class="crm-form-field"
                type="textarea"
                label="Особенности клиники"
              />
              <base-checkbox
                v-model="clinicInfoEditData.viewInDoctis"
                class="crm-form-checkbox"
              >
                <span class="crm-form-checkbox-text">
                  Выводить для doctis.ru
                </span>
              </base-checkbox>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label">
                Виды услуг
              </div>
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="clinicInfoEditData.isOms"
                  :disabled="!checkFeatureAccess({ name: 'Редактирование. Виды услуг. Можно выбрать ОМС', url: '/clinics/:clinicId' })"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text">
                    ОМС
                  </span>
                </b-form-checkbox>
                <!-- :disabled="checkRoleAccess_(['Dis.monitoring.operator'])" -->
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="clinicInfoEditData.isDms"
                  :disabled="!checkFeatureAccess({ name: 'Редактирование. Виды услуг. Можно выбрать ДМС', url: '/clinics/:clinicId' })"
                  name="checkbox-2"
                  :value="true"
                  class="mr-4 ml-4"
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text">
                    ДМС
                  </span>
                </b-form-checkbox>
                <!-- :disabled="checkRoleAccess_(['Dis.monitoring.operator'])" -->
                <b-form-checkbox
                  id="checkbox-3"
                  v-model="clinicInfoEditData.isTelemed"
                  :disabled="!checkFeatureAccess({ name: 'Редактирование. Виды услуг. Можно выбрать Телемед', url: '/clinics/:clinicId' })"
                  name="checkbox-3"
                  :value="true"
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text">
                    Телемед
                  </span>
                </b-form-checkbox>
              </div>

              <div
                v-if="typesOfServicesErrors && checkErrors"
                class="validation-errors"
              >
                <span
                  class="validation-error-text"
                >
                  {{ typesOfServicesErrors[0] }}
                </span>
              </div>
            </div>
          </div>
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label">
                Признак договора
              </div>

              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="checkbox-group-clinicAttributes-edit"
                  v-model="clinicInfoEditData.clinicAttributes"
                  :options="SIGNS_AGENCY_AGREEMENT"
                  :aria-describedby="ariaDescribedby"
                  name="clinicAttributes-edit"
                />
              </b-form-group>
              <div
                v-if="signContractErrors && checkErrors"
                class="validation-errors"
              >
                <span
                  class="validation-error-text"
                >
                  {{ signContractErrors[0] }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label">
                Привязка клиники
              </div>
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  id="checkbox-12"
                  v-model="clinicInfoEditData.isOmsPay"
                  :disabled="!checkFeatureAccess({ name: 'Редактирование. Привязка клиники. Можно выбрать ОМС', url: '/clinics/:clinicId' })"
                  name="checkbox-12"
                  :value="true"
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text">
                    ОМС
                  </span>
                </b-form-checkbox>
                <!-- :disabled="checkRoleAccess_(['Dis.monitoring.operator'])" -->
                <b-form-checkbox
                  id="checkbox-22"
                  v-model="clinicInfoEditData.isDmsPay"
                  :disabled="!checkFeatureAccess({ name: 'Редактирование. Привязка клиники. Можно выбрать ДМС', url: '/clinics/:clinicId' })"
                  name="checkbox-22"
                  :value="true"
                  class="mr-4 ml-4"
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text">
                    ДМС
                  </span>
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div
            v-if="selectedAgencyAgreement"
            class="crm-form-field"
          >
            <div class="crm-form-block">
              <div
                class="crm-label"
                :class="{ required: selectedAgencyAgreement}"
              >
                Номер агентского договора
              </div>

              <b-form-group>
                <b-form-input
                  v-model="$v.clinicInfoEditData.contractNumber.$model"
                  :state="!$v.clinicInfoEditData.contractNumber.$error"
                  :errors="errorsValidation.contractNumber"
                  :input-style="inputStyleProps"
                  :required="selectedAgencyAgreement"
                />
                <b-form-invalid-feedback>
                  Данное поле обязательно*
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label font-weight-bold">
                Дистанционный мониторинг
              </div>
              <div
                title="Недоступно при редактировании"
                class="d-flex align-items-center"
              >
                <b-form-checkbox
                  v-model="clinicInfoEditData.isAddedToDismonitoringAdmin"
                  :value="true"
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text font-weight-bold">
                    Клиника привязана
                  </span>
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Название клиники для приложения
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.title || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                OID
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.medicalOrganizationOID || '—' }}
              </span>
            </div>
          </div>
        </div>

        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Адрес
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.address || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Город
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.city?.title || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Режим работы:
              </p>
              <div class="crm-info-text">
                с {{ clinicInfo.operatingHoursFrom || '—' }}
                до {{ clinicInfo.operatingHoursTo || '—' }}
              </div>
              <div class="crm-info-text">
                {{ clinicInfo.operatingHoursComment || '—' }}
              </div>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                E-mail для гарантийных писем
              </p>
              <template v-if="clinicInfo.contactsForIL?.length">
                <div
                  v-for="(email, index) in clinicInfo.contactsForIL"
                  :key="index"
                  class="crm-info-text"
                >
                  {{ email }}
                </div>
              </template>
              <span
                v-else
                class="crm-info-text"
              >
                {{ '—' }}
              </span>
            </div>
          </div>
        </div>

        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Приоритет клиники
              </p>
              <span class="crm-info-text">
                {{ clinicPriority || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Широта
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.latitude || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Долгота
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.longitude || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field" />
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Услуги
              </p>
              <div
                v-if="clinicInfo.services?.length"
                class="service-list"
              >
                <div
                  v-for="service in clinicInfo.services"
                  :key="service"
                  class="service-item"
                >
                  {{ clinicServices[service] }}
                </div>
              </div>
              <span
                v-else
                class="crm-info-text"
              >
                {{ '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Особенности клиники
              </p>
              <span class="crm-info-text crm-info-text--special">
                {{ clinicInfo.specialComment || '—' }}
              </span>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label">
                Виды услуг
              </div>
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="clinicInfo.isOms"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                  disabled
                >
                  <span class="crm-form-checkbox-text">
                    ОМС
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  id="checkbox-2"
                  v-model="clinicInfo.isDms"
                  name="checkbox-2"
                  :value="true"
                  class="mr-4 ml-4"
                  disabled
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text">
                    ДМС
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  id="checkbox-3"
                  v-model="clinicInfo.isTelemed"
                  name="checkbox-3"
                  :value="true"
                  disabled
                  :unchecked-value="false"
                >
                  <span class="crm-form-checkbox-text">
                    Телемед
                  </span>
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label">
                Признак договора
              </div>

              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  id="checkbox-group-clinicAttributes-preview"
                  v-model="clinicInfo.clinicAttributes"
                  :options="SIGNS_AGENCY_AGREEMENT"
                  :aria-describedby="ariaDescribedby"
                  disabled
                  name="clinicAttributes-preview"
                />
              </b-form-group>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label">
                Привязка клиники
              </div>
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  id="checkbox-12"
                  v-model="clinicInfo.isOmsPay"
                  name="checkbox-12"
                  :value="true"
                  :unchecked-value="false"
                  disabled
                >
                  <span class="crm-form-checkbox-text">
                    ОМС
                  </span>
                </b-form-checkbox>
                <b-form-checkbox
                  id="checkbox-22"
                  v-model="clinicInfo.isDmsPay"
                  name="checkbox-22"
                  :value="true"
                  class="mr-4 ml-4"
                  :unchecked-value="false"
                  disabled
                >
                  <span class="crm-form-checkbox-text">
                    ДМС
                  </span>
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div
            v-if="previewSelectedAgencyAgreement"
            class="crm-form-field"
          >
            <div class="crm-form-block">
              <div class="crm-label">
                Номер агентского договора
              </div>

              <span class="crm-info-text">
                {{ clinicInfo.contractNumber || '—' }}
              </span>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <div class="crm-label font-weight-bold">
                Дистанционный мониторинг
              </div>
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="clinicInfo.isAddedToDismonitoringAdmin"
                  :unchecked-value="false"
                  disabled
                >
                  <span class="crm-form-checkbox-text">
                    Клиника привязана
                  </span>
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="clinics-form-fields">
        <div class="crm-form-field">
          <div class="crm-form-block">
            <p class="crm-info-title">
              Ответственные лица
            </p>
            <span class="crm-info-text">
              {{ responsibles }}
            </span>
          </div>
        </div>
      </div>
      <template v-if="isEdit">
        <div
          v-if="clinicInfoEditData.clinicAttributes.includes(1)"
          class="pb-3"
        >
          <div class="line-title">
            <div class="line-title-inner">
              Оферта
            </div>
          </div>

          <div class="border rounded">
            <div
              v-if="offersShow"
              class="p-3 mb-2"
            >
              <div
                v-for="(offer, index) in clinicInfoEditData.clinicOffers"
                :key="`${offer.title + index}-edit`"
                class="editor-item"
              >
                <div class="mb-2 font-weight-bold">
                  {{ offerTitle(offer.type) }}
                </div>

                <div class="editor-container">
                  <div class="editor-hashtags d-flex">
                    <div
                      v-for="hashtag in HASHTAGS"
                      :key="hashtag.key"
                      class="editor-hashtags__item"
                      @click="copyHashtag(hashtag)"
                    >
                      {{ hashtag.title }}
                    </div>
                  </div>
                  <TextEditor
                    v-model="offer.text"
                    :custom-toolbar="CLINIC_EDITOR_TOOLBAR"
                    :disabled="!isEdit"
                  />

                  <p
                    v-if="checkErrors && !offer.text"
                    class="mt-1 text-danger"
                  >
                    Поле обязательно к заполнению
                  </p>
                </div>
              </div>
            </div>

            <div
              style="cursor: pointer;"
              class="bg-primary rounded-bottom d-flex justify-content-center p-2 "
              @click="offersShow = !offersShow"
            >
              <b-icon
                icon="caret-down-fill"
                variant="light"
                :rotate="offersShow ? 180 : 0"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          v-if="clinicInfo.clinicAttributes.includes(1)"
          class="pb-3"
        >
          <div class="line-title">
            <div class="line-title-inner">
              Оферта
            </div>
          </div>

          <div class="border rounded">
            <div
              v-if="offersShow"
              class="p-3 mb-2"
            >
              <div
                v-for="offer in clinicInfo.clinicOffers"
                :key="`${offer.id}-default`"
                class="editor-item"
              >
                <div class="mb-2 font-weight-bold">
                  {{ offerTitle(offer.type) }}
                </div>

                <div class="editor-container">
                  <div class="editor-hashtags d-flex">
                    <div
                      v-for="hashtag in HASHTAGS"
                      :key="hashtag.key"
                      class="editor-hashtags__item"
                      @click="copyHashtag(hashtag)"
                    >
                      {{ hashtag.title }}
                    </div>
                  </div>
                  <TextEditor
                    v-model="offer.text"
                    :custom-toolbar="CLINIC_EDITOR_TOOLBAR"
                    :disabled="!isEdit"
                  />
                </div>
              </div>
            </div>

            <div
              style="cursor: pointer;"
              class="bg-primary rounded-bottom d-flex justify-content-center p-2 "
              @click="offersShow = !offersShow"
            >
              <b-icon
                icon="caret-down-fill"
                variant="light"
                :rotate="offersShow ? 180 : 0"
              />
            </div>
          </div>
        </div>
      </template>

      <div class="line-title">
        <div class="line-title-inner">
          Контакты клиники
        </div>
      </div>

      <template v-if="isEdit">
        <div
          v-for="(contact, index) in $v.clinicInfoEditData.contacts.$each.$iter"
          :key="index"
          class="clinics-form-fields"
        >
          <base-input
            v-model="contact.position.$model"
            :input-style="inputStyleProps"
            class="crm-form-field"
            label="Должность"
          />

          <base-input
            v-model="contact.fio.$model"
            :input-style="inputStyleProps"
            class="crm-form-field"
            label="ФИО"
          />

          <base-input
            v-model="contact.email.$model"
            :input-style="inputStyleProps"
            :mask="emailMask"
            :guide="false"
            class="crm-form-field"
            label="E-mail"
          />

          <div class="crm-form-field">
            <base-input
              v-model="contact.phoneNumber.$model"
              :error="contact.phoneNumber.$error"
              :errors="['Поле не может быть пустым']"
              :input-style="{ ...inputStyleProps, width: '150px'}"
              :guide="false"
              class="crm-form-field"
              label="Телефон"
              required
            />

            <div class="crm-form-field">
              <div class="crm-form-block">
                <p class="crm-info-title">
                  Осн. контакт
                </p>
                <span class="crm-info-text contact">
                  <base-checkbox
                    v-model="contact.isMain.$model"
                    class="checkbox"
                  />
                  <icon-delete
                    class="crm-icon-delete contact-delete"
                    @click="deleteContact(index)"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="clinics-form-fields">
          <base-button
            :type="$const.SECONDARY_BUTTON"
            class="width-unset without-border add-contact"
            @click="addContact"
          >
            <span>Добавить контакт</span>
          </base-button>
        </div>

        <template v-if="clinicInfoEditData.isAddedToDismonitoringAdmin || clinicInfoEditData.isTelemed">
          <div class="line-title">
            <div class="line-title-inner">
              {{ clinicInfoEditData.isAddedToDismonitoringAdmin ? 'Профиль администратора дис.мониторинга' : 'Профиль администратора' }}
            </div>
          </div>

          <div class="clinics-form-fields">
            <div class="crm-form-field">
              <base-input
                v-model="$v.clinicInfoEditData.authorization.login.$model"
                :input-style="inputStyleProps"
                :disabled="hadAuthorization"
                :error="$v.clinicInfoEditData.authorization.login.$error"
                :errors="errorsValidation.authorization.login"
                class="crm-form-field"
                label="Логин администратора"
              />

              <base-input
                ref="password"
                v-model="$v.clinicInfoEditData.authorization.password.$model"
                :type="showPassword ? 'text' : 'password'"
                :input-style="inputStyleProps"
                class="crm-form-field"
                label="Пароль администратора"
                autocomplete="new-password"
                :error="$v.clinicInfoEditData.authorization.password.$error"
                :errors="errorsValidation.authorization.password"
              >
                <template
                  v-slot:suffix
                >
                  <icon-eye
                    :class="[ 'crm-icon-eye', { active: showPassword }]"
                    @click="toggleShowPassword"
                  />
                </template>
              </base-input>
            </div>
            <div class="crm-form-field" />
          </div>
        </template>

        <div class="line-title">
          <div class="line-title-inner">
            Документы клиники
          </div>
        </div>

        <b-row v-if="clinicInfoEditData.documents.length">
          <b-col>
            <b-form-group>
              <b-table
                :items="clinicInfoEditData.documents"
                class="bg-white border-secondary w-50"
                bordered
                hover
                :small="true"
                :fields="fields"
              >
                <template #cell(id)="row">
                  <b-button
                    v-b-tooltip.hover
                    size="sm"
                    :title="row.item.title"
                    variant="primary"
                    class="ml-2"
                    @click="saveFile(row)"
                  >
                    <b-icon icon="file-earmark-fill" />
                    <span class="ml-2">{{ documentType(row) }}</span>
                  </b-button>
                </template>
                <template #cell(actions)="row">
                  <b-button
                    v-b-tooltip.hover
                    size="sm"
                    title="Редактировать"
                    variant="primary"
                    class="ml-2"
                    @click="openEditDocumentModal(row)"
                  >
                    <b-icon icon="pencil-fill" />
                  </b-button>
                  <b-button
                    v-b-tooltip.hover
                    size="sm"
                    title="Удалить"
                    variant="danger"
                    class="ml-2"
                    @click="deleteDocument(row)"
                  >
                    <b-icon icon="x" />
                  </b-button>
                </template>
              </b-table>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              size="sm"
              variant="primary"
              @click="openAddDocumentModal"
            >
              Добавить файл
            </b-button>
          </b-col>
        </b-row>
      </template>

      <template v-else>
        <div
          v-for="(contact, i) in clinicInfo.contacts"
          :key="i"
          class="clinics-form-fields"
        >
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Должность
              </p>
              <span class="crm-info-text">
                {{ contact.position || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                ФИО
              </p>
              <span class="crm-info-text">
                {{ contact.fio || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                E-mail
              </p>
              <span class="crm-info-text">
                {{ contact.email || '—' }}
              </span>
            </div>
          </div>

          <div class="crm-form-field">
            <div class="crm-form-field">
              <div class="crm-form-block">
                <p class="crm-info-title">
                  Телефон
                </p>
                <span class="crm-info-text">
                  {{ contact.phoneNumber || '—' }}
                </span>
              </div>
            </div>
            <div class="crm-form-field">
              <div class="crm-form-block">
                <p class="crm-info-title">
                  Осн. контакт
                </p>
                <span class="crm-info-text">
                  <base-checkbox
                    :value="contact.isMain"
                    :disabled="true"
                    class="checkbox"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="line-title">
          <div class="line-title-inner">
            Профиль администратора
          </div>
        </div>

        <div class="clinics-form-fields">
          <div class="crm-form-field">
            <div class="crm-form-block">
              <p class="crm-info-title">
                Логин администратора
              </p>
              <span class="crm-info-text">
                {{ clinicInfo.authorization && clinicInfo.authorization.login ? clinicInfo.authorization.login : '—' }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <div
        v-if="isEdit"
        class="crm-wrapper-buttons crm-wrapper-buttons_clinic-edit"
      >
        <base-button
          :type="$const.SECONDARY_BUTTON"
          class="crm-button"
          @click="onClickCancel"
        >
          Отменить
        </base-button>

        <!-- v-if="!checkRoleAccess_(['Tech.operator'])" -->
        <base-button
          v-if="checkFeatureAccess({ name: 'Редактирование. Кнопка Сохранить', url: '/clinics/:clinicId' })"
          :type="$const.PRIMARY_BUTTON"
          :loading="isSaving"
          class="crm-button"
          @click="onClickSave"
        >
          Сохранить
        </base-button>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */

import Bus from '@/eventBus';
import { api } from '@/helpers/api';
import { mapGetters } from 'vuex';
import * as types from '@/store/types';
import {
  CLINIC_PRIORITIES,
  CLINIC_SERVICES,
  SIGNS_AGENCY_AGREEMENT,
  OFFERS,
  HASHTAGS,
  CLINIC_EDITOR_TOOLBAR,
} from '@/helpers/consts';
import { validationMixin } from 'vuelidate';
import { mixinRoles } from '@/mixins';
import { required } from 'vuelidate/lib/validators';
import {
  showMessage,
  createCoordMask,
  saveFile,
} from '@/helpers/utils';

import emailMask from 'text-mask-addons/dist/emailMask';

import {
  BaseButton,
  BaseInput,
  // BaseRadioButton,
  BaseCheckbox,
  // BaseAsyncSelect,
} from '@/components/base';
import TextEditor from '@/components/common/TextEditor';

import Loading from '@/components/Loading';
import IconEdit from 'assets/images/edit_icon.svg';
import IconEye from 'assets/images/eye_1.svg';
import IconDelete from 'assets/images/delete_icon.svg';
import ClinicLegalPersonEdit from '@/components/Clinics/ClinicPage/ClinicLegalPersonEdit';

export default {
  name: 'ClinicInfo',
  components: {
    // BaseRadioButton,
    BaseButton,
    Loading,
    IconEdit,
    IconEye,
    IconDelete,
    BaseInput,
    BaseCheckbox,
    TextEditor,
    ClinicLegalPersonEdit,
    // BaseAsyncSelect,
  },
  mixins: [validationMixin, mixinRoles],
  props: {},
  data() {
    return {
      isLoading: false,
      checkErrors: false,
      legalPersons: [],
      isEditFace: false,
      isAddClinicFace: false,
      thisppp: {},
      offersShow: false,
      HASHTAGS,
      CLINIC_EDITOR_TOOLBAR,
      fields: [
        {
          key: 'id',
          label: 'Документ',
          thClass: 'text-center',
        },
        {
          key: 'actions',
          label: 'Изменения',
          thClass: 'text-center',
          tdClass: 'align-middle',
          class: 'text-center',
        },
      ],
      cities: [],
      networks: [],
      newNetwork: false,
      newNetworkName: null,
      newLegal: false,
      hadAuthorization: false,
      emailMask,
      mask: ['+', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      isSaving: false,
      inputStyleProps: {
        padding: '11px 15px 12px',
        resize: 'none',
      },
      isOms: false,
      isDms: false,
      isOmsPay: false,
      isDmsPay: false,
      isTelemed: false,
      clinicPriorities: CLINIC_PRIORITIES,
      clinicServices: CLINIC_SERVICES,
      maskLatitude: createCoordMask('latitude'),
      maskLongitude: createCoordMask('longitude'),
      unwatch: null,
      showPassword: false,
      isAdminEdit: false,
      SIGNS_AGENCY_AGREEMENT,
      clinicInfoEditData: {
        id: null,
        title: '',
        appTitle: '',
        clinicNetwork: null,
        city: null,
        latitude: null,
        longitude: null,
        isOms: false,
        isDms: false,
        isOmsPay: false,
        isDmsPay: false,
        isTelemed: false,
        contractNumber: null,
        clinicOffers: [],
        contactsForIL: [
          {
            email: '',
          },
        ],
        operatingHoursFrom: null,
        viewInDoctis: false,
        operatingHoursTo: null,
        priority: 0,
        operatingHoursComment: null,
        leader: {
          fio: null,
          position: null,
        },
        legalPerson: {
          contacts: [
            {
              email: null,
              fio: null,
              id: 0,
              legalPersonId: 0,
              phoneNumber: null,
              position: null,
            },
          ],
          id: 0,
          inn: null,
          kpp: null,
          leaderFio: null,
          leaderPosition: null,
          name: null,
          ogrn: null,
          site: null,
        },
        address: null,
        webSite: null,
        // legalInformation: {
        //   inn: null,
        //   kpp: null,
        //   ogrn: null,
        // },
        authorization: {
          login: null,
          password: null,
        },
        description: null,
        specialComment: null,
        // isTelemed: false,
        specializations: [],
        doctors: [],
        photoFile: [],
        agreementFiles: {},
        contacts: [],
      },
    };
  },
  validations() {
    return {
      clinicInfoEditData: {
        title: { required },
        appTitle: {
          // required,
        },
        clinicNetwork: {
          // required
        },
        priority: {
          required,
        },
        city: { required },
        longitude: {
          // required: this.clinicInfo.isTelemed ? required : () => true,
          // isValid: this.clinicInfo.isTelemed ? (val) => /^-?\d{2,3}.\d+$/.test(val) : () => true,
        },
        contractNumber: {
          required: this.selectedAgencyAgreement ? required : () => true,
        },
        latitude: {
          // required: this.clinicInfo.isTelemed ? required : () => true,
          // isValid: this.clinicInfo.isTelemed ? (val) => /^-?\d{2,3}.\d+$/.test(val) : () => true,
        },
        address: { required },
        // legalInformation: {
        //   inn: { required },
        //   kpp: { required },
        //   ogrn: { required },
        // },
        legalPerson: {
          required,
          contacts: {
            $each: {
              position: {
                required,
              },
              phoneNumber: {
                required,
              },
              fio: {
                required,
              },
              email: {
                // required,
              },
            },
          },
          inn: {
            // required,
          },
          kpp: {
            // required,
          },
          ogrn: {
            // required,
          },
          name: {
            // required,
          },
          leaderFio: {
            // required,
          },
          leaderPosition: {
            // required,
          },
          site: {
            // required
          },
        },
        authorization: {
          login: {
            required: this.clinicInfoEditData.isAddedToDismonitoringAdmin || this.clinicInfoEditData.isTelemed ? required : () => true,
          },
          password: {
            required: (value) => {
              if (this.hadAuthorization) {
                return !value || !!(value && value.length >= 6);
              }

              if (!this.clinicInfoEditData.authorization.login) return true;

              return !!(value && value.length >= 6);
            },
          },
        },
        contacts: {
          $each: {
            phoneNumber: {
              required,
            },
            email: {
              // required
            },
            position: {
              // required,
            },
            fio: {
              // required,
            },
            comment: {
              // required,
            },
            isMain: {
              // required,
            },
          },
        },
        contactsForIL: {
          $each: {
            email: {
              required,
              // eslint-disable-next-line no-useless-escape
              isValid: (val) => /^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/.test(val),
            },
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      isChangedInfo: types.GET_IS_CHANGED_INFO,
    }),
    responsibles() {
      if (this.clinicInfo.responsibles.length === 0) return '—';

      return this.clinicInfo.responsibles.join(', ');
    },
    isCanNetworkChange() {
      return this.newLegal || (!this.newLegal && this.clinicInfoEditData.legalPerson && this.clinicInfoEditData.legalPerson.network === null);
    },
    getActualNetworkForLegalPerson() {
      if (this.newNetwork) return this.newNetworkName ? { id: 0, title: this.newNetworkName } : null;
      return this.clinicInfoEditData.clinicNetwork ? { id: this.clinicInfoEditData.clinicNetwork.id } : null;
    },
    offersError() {
      return this.clinicInfoEditData.clinicOffers.some((item) => !item.text);
    },
    isNeedUpdateLegarPerson() {
      return true;
      // if (!this.isCanNetworkChange) return false;
      // const initNetwork = this.clinicInfo.legalPerson.network ? this.clinicInfo.legalPerson.network.id : null;
      // const actualNetwork = this.getActualNetworkForLegalPerson ? this.getActualNetworkForLegalPerson.id : null;
      // if (initNetwork === actualNetwork) return false;
      // return true;
    },
    errorsValidation() {
      const errors = {};

      errors.legalPerson = [];
      if (!this.$v.clinicInfoEditData.legalPerson.required) {
        errors.legalPerson.push('Поле не может быть пустым');
      }

      errors.legalPersonName = [];
      if (!this.$v.clinicInfoEditData.legalPerson.name.required) {
        errors.legalPersonName.push('Поле не может быть пустым');
      }

      errors.inn = [];
      if (!this.$v.clinicInfoEditData.legalPerson.inn.required) {
        errors.inn.push('Поле не может быть пустым');
      }

      errors.ogrn = [];
      if (!this.$v.clinicInfoEditData.legalPerson.ogrn.required) {
        errors.ogrn.push('Поле не может быть пустым');
      }

      errors.kpp = [];
      if (!this.$v.clinicInfoEditData.legalPerson.kpp.required) {
        errors.kpp.push('Поле не может быть пустым');
      }

      errors.leaderPosition = [];
      if (!this.$v.clinicInfoEditData.legalPerson.leaderPosition.required) {
        errors.leaderPosition.push('Поле не может быть пустым');
      }

      errors.leaderFio = [];
      if (!this.$v.clinicInfoEditData.legalPerson.leaderFio.required) {
        errors.leaderFio.push('Поле не может быть пустым');
      }

      errors.title = [];
      if (!this.$v.clinicInfoEditData.title.required) {
        errors.title.push('Поле не может быть пустым');
      }

      errors.appTitle = [];
      if (!this.$v.clinicInfoEditData.appTitle.required) {
        errors.appTitle.push('Поле не может быть пустым');
      }

      errors.network = [];
      if (!this.$v.clinicInfoEditData.clinicNetwork.required) {
        errors.network.push('Поле не может быть пустым');
      }

      errors.city = [];
      if (!this.$v.clinicInfoEditData.city.required) {
        errors.city.push('Поле не может быть пустым');
      }

      errors.priority = [];
      if (!this.$v.clinicInfoEditData.priority.required) {
        errors.priority.push('Поле не может быть пустым');
      }

      errors.contractNumber = [];
      if (!this.$v.clinicInfoEditData.contractNumber.required) {
        errors.contractNumber.push('Поле не может быть пустым');
      }

      // errors.latitude = [];
      // if (!this.$v.clinicInfoEditData.latitude.required) {
      //   errors.latitude.push('Поле не может быть пустым');
      // }
      // if (!this.$v.clinicInfoEditData.latitude.isValid) {
      //   errors.latitude.push('Некорректное значение');
      // }

      // errors.longitude = [];
      // if (!this.$v.clinicInfoEditData.longitude.required) {
      //   errors.longitude.push('Поле не может быть пустым');
      // }
      // if (!this.$v.clinicInfoEditData.longitude.isValid) {
      //   errors.longitude.push('Некорректное значение');
      // }

      errors.address = [];
      if (!this.$v.clinicInfoEditData.address.required) {
        errors.address.push('Поле не может быть пустым');
      }

      errors.authorization = { login: [], password: [] };

      if (!this.$v.clinicInfoEditData.authorization.login.required) {
        errors.authorization.login.push('Поле не может быть пустым');
      }

      if (!this.$v.clinicInfoEditData.authorization.password.required) {
        errors.authorization.password.push('Длина не менее 6 знаков');
      }

      return errors;
    },

    typesOfServicesErrors() {
      const errors = [];
      if (
        !this.clinicInfoEditData.isOms
        && !this.clinicInfoEditData.isDms
        && !this.clinicInfoEditData.isTelemed
      ) {
        errors.push('Выберите хотя-бы одну');
      }

      if (errors.length) return errors;
      return false;
    },
    signContractErrors() {
      const errors = [];
      if (
        !this.clinicInfoEditData.clinicAttributes
        || !this.clinicInfoEditData.clinicAttributes.length
      ) {
        errors.push('Выберите хотя-бы одну');
      }

      if (errors.length) return errors;
      return false;
    },
    isEdit: {
      get() {
        return this.$store.state.Clinic.isEditClinicInfo;
      },
      set(newVal) {
        this.$store.commit(this.$types.CLINIC_INFO_IS_EDIT_SET, newVal);
      },
    },
    clinicInfo() {
      const { info } = this.$store.state.Clinic.clinic;
      let clinicOffers = JSON.parse(JSON.stringify(info.clinicOffers));

      if (clinicOffers && clinicOffers.length) {
        clinicOffers = clinicOffers.sort((a, b) => a.type - b.type);
      }

      return { ...info, clinicOffers };
    },
    clinicPriority() {
      const index = this.clinicInfo.priority;
      const priority = this.clinicPriorities.find((p) => p.index === index);
      return priority ? priority.title : null;
    },
    previewSelectedAgencyAgreement() {
      if (!this.clinicInfo.clinicAttributes) return;

      return this.clinicInfo.clinicAttributes.some((item) => item === 0);
    },
    selectedAgencyAgreement() {
      if (!this.clinicInfoEditData.clinicAttributes) return;

      return this.clinicInfoEditData.clinicAttributes.some((item) => item === 0);
    },
  },
  watch: {
    isLoading() {
      if (!this.isLoading && this.isEdit) {
        this.editClinic();
      }
    },
    clinicInfo() {
      if (this.clinicInfo.legalPerson.id) this.newLegal = false;
      this.setEditClinic();
    },
  },
  async created() {
    // !!! нужно ли это в фичи?
    if (this.checkRoleAccess(['ClinicAdministrator'])) this.isEdit = false;
    this.isLoading = true;
    try {
      this.networks = await this.$store.dispatch(this.$types.NETWORK_LIST_FETCH);
      if (this.clinicInfo?.legalPerson) await this.fetchLegalPersons({ skip: 0, query: this.clinicInfo.legalPerson.name });
      this.cities = (await this.$store.dispatch(this.$types.CITIES_FETCH, { query: '' })).sort((a, b) => a.name.localeCompare(b.name));
    } catch (e) {
      console.error(e);
    } finally {
      this.isLoading = false;
    }
  },
  beforeDestroy() {
    this.isEdit = false;
  },
  methods: {
    // async loadInitialData() {
    //   this.isLoading = true;
    //   try {
    //     // 1. Загружаем сети
    //     this.networks = await this.$store.dispatch(this.$types.NETWORK_LIST_FETCH);

    //     // 2. Если есть юридическое лицо, загружаем связанные данные
    //     if (this.clinicInfo?.legalPerson) {
    //       await this.fetchLegalPersons({
    //         skip: 0,
    //         query: this.clinicInfo.legalPerson.name,
    //       });
    //     }

    //     // 3. Загружаем города
    //     const cities = await this.$store.dispatch(
    //       this.$types.CITIES_FETCH,
    //       { query: '' },
    //     );
    //     this.cities = cities.sort((a, b) => a.name.localeCompare(b.name));

    //     // 4. Возвращаем обновленные данные клиники
    //     return await this.$store.dispatch(
    //       this.$types.CLINIC_GET_BY_ID,
    //       this.clinicInfo.id,
    //     );
    //   } catch (e) {
    //     console.error('Ошибка при загрузке данных:', e);
    //     throw e;
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    openDownloadFileModal() {
      Bus.$emit('open-modal:file-upload-clinic', { saveFileCallback: this.saveFileCallback, multiple: false, fileApi: 'File/clinicdocument/upload' });
    },
    setNewLegalPerson() {
      this.clinicInfoEditData.legalPerson = {
        contacts: [
          {
            email: null,
            fio: null,
            id: 0,
            legalPersonId: 0,
            phoneNumber: null,
            position: null,
          },
        ],
        id: 0,
        inn: null,
        kpp: null,
        leaderFio: null,
        leaderPosition: null,
        name: null,
        ogrn: null,
        site: null,
        network: null,
      };
    },
    offerTitle(type) {
      return OFFERS.find((item) => (item.id === type))?.title;
    },
    async copyHashtag(hashtag) {
      try {
        await navigator.clipboard.writeText(hashtag.key);

        showMessage({
          type: 'success',
          title: 'Хештег скопирован в буфер обмена',
          message: 'Вставьте хештег, куда вам удобно (ctrl+v)',
        });
      } catch (e) {
        console.error(e);
        showMessage({
          type: 'danger',
          title: 'Что-то пошло не так',
          message: e,
        });
      }
    },
    documentType(row) {
      if (row.item.type === 1) {
        return 'Договор';
      }
      if (row.item.type === 3) {
        return 'Лицензия';
      }
      if (row.item.type === 4) {
        return 'Прайс';
      }
      if (row.item.type === 5) {
        return 'Скан';
      }
      return 'Учредительные документ';
    },
    async saveFile(row) {
      const { data: file } = await api.get(`File/clinicdocument/${row.item.fileId}`, { responseType: 'blob' });

      saveFile(file, { name: row.item.title });
    },
    openEditDocumentModal(row) {
      this.$store.commit(this.$types.OPEN_MODAL, {
        name: 'EditClinicDocument',
        props: {
          currentDocumentInfo: row.item,
        },
      });
    },
    async deleteDocument(row) {
      const document = row.item;
      if (document.id) {
        await this.$store.dispatch(this.$types.CLINIC_DOCUMENTS_DELETE, {
          document,
          isFetch: false,
        });
        const clinicData = await this.$store.dispatch(this.$types.CLINIC_FETCH, this.clinicInfoEditData.id);
        this.$store.commit(this.$types.CLINIC_SET, {
          ...clinicData,
          info: clinicData,
        });
      }
    },
    openAddDocumentModal() {
      this.$store.commit(this.$types.OPEN_MODAL, {
        name: 'AddClinicDocument',
        props: {
          clinicId: this.clinicInfoEditData.id,
        },
      });
    },
    addContact() {
      const newContact = {
        email: null,
        fio: null,
        comment: null,
        isMain: false,
        phoneNumber: null,
        position: null,
      };

      this.clinicInfoEditData.contacts = [...this.clinicInfoEditData.contacts, newContact];
    },
    addLegalPersonContact() {
      const newContact = {
        id: 0,
        legalPersonId: this.clinicInfoEditData.legalPerson.id,
        email: null,
        fio: null,
        phoneNumber: null,
        position: null,
      };

      this.clinicInfoEditData.legalPerson.contacts = [...this.clinicInfoEditData.legalPerson.contacts, newContact];
    },
    setWatcher() {
      this.$store.commit(this.$types.CLINICS_SET_IS_CHANGED_CLINIC_INFO, false);
      this.unwatch = this.$watch('clinicInfoEditData',
        () => {
          if (this.unwatch) {
            this.unwatch();
          }
          this.$store.commit(this.$types.CLINICS_SET_IS_CHANGED_CLINIC_INFO, true);
        },
        {
          deep: true,
        });
    },
    async fetchLegalPersons({ skip, take, query }) {
      const clinics = await this.$store.dispatch(this.$types.LEGAL_PERSONS_FETCH, {
        skip,
        take,
        query,
      });
      this.thisppp = clinics;
      return clinics;
    },
    setEditClinic() {
      const authorization = this.clinicInfo.authorization ? { ...this.clinicInfo.authorization } : { login: null, password: null };

      if (authorization.login) {
        this.hadAuthorization = true;
      }

      const newClinicInfoObject = JSON.parse(JSON.stringify(this.clinicInfo));

      if (!newClinicInfoObject.clinicOffers || !newClinicInfoObject.clinicOffers.length) {
        newClinicInfoObject.clinicOffers = OFFERS.map((item) => ({ type: item.id, title: item.title, text: '' }));
      }

      this.clinicInfoEditData = {
        ...newClinicInfoObject,
        agreementFiles: { ...newClinicInfoObject.agreementFiles },
        authorization,
        latitude: newClinicInfoObject.latitude ? newClinicInfoObject.latitude.toString() : null,
        longitude: newClinicInfoObject.longitude ? newClinicInfoObject.longitude.toString() : null,
        city: newClinicInfoObject.city
          ? { id: newClinicInfoObject.city.id, name: newClinicInfoObject.city.title } : null,
        // clinicNetwork: newClinicInfoObject.clinicNetwork
        //   ? { id: newClinicInfoObject.clinicNetwork.id, title: newClinicInfoObject.clinicNetwork.title } : null,
        contactsForIL: newClinicInfoObject.contactsForIL.map((e) => ({ email: e })),
        clinicAttributes: newClinicInfoObject.clinicAttributes ? newClinicInfoObject.clinicAttributes : [],
      };

      // if (this.clinicInfoEditData.contacts.length === 0) this.addContact();
      // if (this.clinicInfoEditData.legalPerson.contacts.length === 0) this.addLegalPersonContact();
    },
    editClinic() {
      this.isEdit = true;

      this.setEditClinic();
      this.setWatcher();

      this.$v.$touch();
    },
    editClinicFace() {
      this.isEditFace = true;
    },
    addClinicFace() {
      this.isAddClinicFace = !this.isAddClinicFace;
    },
    onClickCancel() {
      if (this.isChangedInfo) {
        if (!confirm('Несохраненная информация будет удалена, продолжить?')) {
          return;
        }
      }

      this.$store.commit(this.$types.CLINICS_SET_IS_CHANGED_CLINIC_INFO, false);
      this.isEdit = false;
      this.setEditClinic();
    },
    onClickCancelFace() {
      this.isEditFace = false;
    },
    async toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    async onClickSave() {
      this.setWatcher();
      this.checkErrors = true;
      this.$v.$touch();

      if (
        this.$v.$error
        || this.typesOfServicesErrors
        || this.signContractErrors
      ) {
        showMessage({
          type: 'warning',
          title: 'Ошибка валидации',
          message: 'Проверьте правильность заполнения полей',
        });
        return;
      }
      if (
        this.clinicInfoEditData.clinicAttributes.includes(1)
        && this.offersError
      ) {
        showMessage({
          type: 'warning',
          title: 'Ошибка валидации "Оферта"',
          message: 'Проверьте правильность заполнения полей',
        });
        return;
      }

      // const clinicNetwork = this.newNetwork ? { id: 0, title: this.newNetworkName } : this.clinicInfoEditData.clinicNetwork;
      const contacts = this.clinicInfoEditData.contacts.map((c) => ({ ...c, email: c.email || null }));
      const contactsForIL = this.clinicInfoEditData.contactsForIL.map((c) => c.email);

      const preformattedClinicInfo = {
        ...this.clinicInfoEditData,
        appTitle: this.clinicInfoEditData.title,
        documents: this.clinicInfoEditData.documents.map((doc) => ({
          ...doc,
          status: doc.status?.value,
          subtype: doc.subtype?.value,
        })),
        // clinicNetwork,
        contacts,
        contactsForIL,
      };

      delete preformattedClinicInfo.clinicNetwork;
      delete preformattedClinicInfo.legalPerson;

      try {
        this.isSaving = true;

        let legalPersonId = null;

        if (this.newLegal) {
          legalPersonId = await this.createOrUpdateLegalPerson();
        } else {
          legalPersonId = this.clinicInfoEditData.legalPerson.id;
          // if (this.isNeedUpdateLegarPerson) await this.createOrUpdateLegalPerson();
        }
        preformattedClinicInfo.legalPerson = { id: legalPersonId };

        // if (this.clinicInfo?.isAddedToDismonitoringOperator !== this.clinicInfoEditData.isAddedToDismonitoringOperator) {
        //   await this.$store.dispatch(this.$types.CLINIC_DISMONITORING_BIND_TOGGLE, {
        //     clinicId: this.clinicInfo.id,
        //     isBind: this.clinicInfoEditData.isAddedToDismonitoringOperator,
        //   });
        // }

        if (this.$store.state.Clinic.clinic.id) {
          const clinicInfo = await this.$store.dispatch(this.$types.CLINIC_UPDATE, preformattedClinicInfo);
          this.$store.commit(this.$types.CLINIC_SET, { ...clinicInfo, info: clinicInfo });
          this.isEdit = false;
          this.setEditClinic();
        } else {
          const clinicInfo = await this.$store.dispatch(this.$types.CLINIC_CREATE, preformattedClinicInfo);

          this.$store.commit(this.$types.CLINIC_SET, { ...this.$store.state.Clinic.clinic, info: clinicInfo });
          this.isEdit = false;
          this.setEditClinic();
        }
      } catch (error) {
        const message = error.response.data;
        showMessage({
          type: 'error',
          title: 'Ошибка',
          // message: `${message} Задайте уникальный логин администратора.`,
          message: `${message}`,
        });
      } finally {
        this.isSaving = false;
      }
    },
    // async createOrUpdateLegalPerson() {
    //   try {
    //     // Создаем копию объекта, чтобы не мутировать исходные данные
    //     const legalPersonParam = {
    //       ...this.thisppp[0], // Копируем все существующие поля
    //       leaderFio: 'testUpdatedДоктис', // Обновляем нужное поле
    //       network: this.getActualNetworkForLegalPerson,
    //     };

    //     console.log('Отправляемые данные:', JSON.stringify(legalPersonParam, null, 2));
    //     const action = this.$types.LEGAL_ENTITIES_UPDATE;
    //     const { data } = await this.$store.dispatch(action, legalPersonParam);
    //     console.log('Ответ сервера:', data);
    //     return data.id;
    //   } catch (error) {
    //     console.error('Ошибка при обновлении:', error);
    //     return null;
    //   }
    // },
    onClickOpenFileModal() {
      Bus.$emit('open-modal:file-upload', { saveFileCallback: this.saveFileCallback, multiple: true });
    },
    addEmail() {
      this.clinicInfoEditData.contactsForIL.push({ email: '' });
    },
    deleteEmail(index) {
      this.clinicInfoEditData.contactsForIL.splice(index, 1);
    },
    deleteContact(index) {
      this.clinicInfoEditData.contacts.splice(index, 1);
    },
    deleteLegalPersonContact(index) {
      this.clinicInfoEditData.legalPerson.contacts.splice(index, 1);
    },
    async handleLegalPersonUpdated({ success }) {
      if (success) {
        window.location.reload();
      }
    },
    handleCloseLegalPersonEdit() {
      this.isEditFace = false;
      this.isAddClinicFace = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.crm-title-row {
  display: flex;
  justify-content: space-between;
}

.clinic-title {
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin-right: 30px;
  margin-bottom: 30px;
  flex: 1;
}

::v-deep.edit-btn {
  border-radius: 5px;
  cursor: pointer;
  flex-shrink: 0;

  &.active {
    background-color: $blue;

    path {
      fill: white;
    }
  }
}

.clinic-info {
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 1px;
}

.crm-form-block {
  width: 100%;
}

// eslint-disable-next-line vue-scoped-css/no-unused-selector
.crm-info {
  &-title {
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    margin: 0 0 10px 0;
    color: #707070;

    &.flex {
      display: flex;
    }
  }

  &-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    & + & {
      margin-top: 10px;
    }

    &.contact {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }

    a {
      color: $blue;
      text-decoration: none;
    }
  }
}

.crm-form-field {
  .divide-line {
    align-self: center;
    height: 1px;
    width: 30px;
    background-color: #323232;
    flex-shrink: 0;
    margin: 0 20px;
  }

  .crm-label {
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    margin: 0 0 10px 0;
    color: #707070;
  }
}

::v-deep.coord-input {
  .crm-wrap-input.with-prefix {
    .crm-base-input {
      padding-left: 40px !important;
    }
  }
}

::v-deep.crm-icon-cross {
  margin-right: 15px;
  path {
    fill: $blue;
  }
}

::v-deep.crm-icon-eye {
  cursor: pointer;

  &:hover,
  &.active {
    path {
      fill: $blue;
    }
  }
}

.line-title {
  position: relative;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #979797;
  margin-bottom: 30px;

  &::before {
    position: absolute;
    content: '';
    display: block;
    height: 1px;
    background: #E0E0E0;
    top: calc(50% + 1px);
    left: 0;
    right: 0;
    z-index: 0;
  }

  &-inner {
    position: relative;
    z-index: 1;
    background-color: #fff;
    padding-right: 20px;
    display: inline-block;
  }
}

.clinics-form-fields + .line-title {
  margin-top: 50px;
}

::v-deep.crm-radio-input:checked + .crm-radio-text {
  color: $blue;
}

.crm-radio-buttons_vertical {
  flex-direction: column;
  margin-bottom: 15px;

  .crm-radio-button {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}

::v-deep.person-select {
  .vs__dropdown-toggle {
    width: 100%;
  }
}

::v-deep.crm-form-input {
  &-prefix {
    align-self: center;
    margin-right: 10px;

    &.crm-bold {
      font-weight: 500;
    }
  }

  &-postfix {
    align-self: center;
    margin-left: 10px;

    &.crm-bold {
      font-weight: 500;
    }
  }

  & + .crm-form-input {
    margin-left: 20px;
  }
}

::v-deep.crm-button {
  &.add-email, &.add-contact {
    padding-left: 0;
    padding-right: 0;
    width: auto;
  }

  &.add-contact {
    margin-top: -20px;
  }
}

.crm-form-field-email {
  display: flex;

  .crm-form-email-delete {
    margin-left: 10px;
    margin-top: 5px;
  }
}

::v-deep.crm-form-field-email + .crm-form-field-email {
  margin-top: 10px;
}

.crm-form-checkbox-list {
  display: flex;
  flex-wrap: wrap;
  margin: -10px -15px 0;

  .crm-form-checkbox {
    margin: 10px 15px;
  }
}

.crm-form-checkbox-text {
  font-size: 14px;
  line-height: 18px;
}

.clinics-form-fields .crm-form-field:not(:last-child) {
  margin-right: 20px;
}

.crm-icon-delete {
  cursor: pointer;
}

.contact-delete {
  margin-left: 10px;
}

.contact-legal-delete {
  align-self: flex-end;
  margin-left: -10px;
  margin-bottom: 5px;
}

.service-list {
  display: flex;
  flex-wrap: wrap;
  margin: -5px;

  .service-item {
    margin: 5px;
    padding: 10px 15px;
    font-size: 16px;
    line-height: 20px;
    background: #F3F3F3;
    border-radius: 20px;
  }
}

.crm-info-text--special {
  white-space: pre-line;
}

.editor-item {
  margin-bottom: 50px;
}

.editor-container {
  position: relative;
  transform: translate(0, 39px);
}

.editor-hashtags {
  position: absolute;
  width: 100%;
  padding: 6px;
  height: 40px;
  top: 8px;
  left: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border: 1px solid #ccc;

  &__item {
    padding: 3px 6px;
    font-size: 13px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: .15s;

    &:hover {
      border: 1px solid #133bd3;
    }

    &:not(:last-child) {
      margin-right: 20px;
    }
  }
}

::v-deep .ql-toolbar {
  transform: translate(0, -39px);
}
</style>
